document.addEventListener('DOMContentLoaded', function () {
  // MODAL OPENING LOGIC
  const openButtons = document.querySelectorAll('.open-modal');
  const modals = document.querySelectorAll('.modal');
  const closeButtons = document.querySelectorAll('.modal-close');

  openButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();  // Prevent link navigation
      const target = this.getAttribute('data-modal');
      const modal = document.getElementById(target);
      if (modal) {
        modal.classList.add('active');
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', function () {
      this.closest('.modal').classList.remove('active');
    });
  });

  modals.forEach(modal => {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });
  });

  // ACCORDION TOGGLE LOGIC
  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach((item, index) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');

    // Open the first item by default
    if (index === 0) {
      header.classList.add('active');
      content.classList.add('open');
    }

    header.addEventListener('click', function () {
      accordionItems.forEach(otherItem => {
        const otherHeader = otherItem.querySelector('.accordion-header');
        const otherContent = otherItem.querySelector('.accordion-content');

        // Collapse all except current
        if (otherItem !== item) {
          otherHeader.classList.remove('active');
          otherContent.classList.remove('open');
        }
      });

      // Toggle current item
      header.classList.toggle('active');
      content.classList.toggle('open');
    });
  });
});